import './OnboardingPages.scss';

import React, {useEffect, useState} from 'react';
import {Alert, Button, Col, Container, Row, Spinner} from "react-bootstrap";
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import Form from "react-bootstrap/Form";
import {Formik} from "formik";
import {useLocation, useNavigate} from "react-router-dom";
import * as yup from "yup";
import {CredentialsService} from "../../../services/api/CredientialsService";
import {REGISTER_EMAIL_CONFIRM} from "../../../services/PageUtils";
import ErrorText from "../../../components/ErrorText";

interface Props {

}

const RegisterCredentials = ({}: Props) => {

    const location: any = useLocation();
    const navigate = useNavigate();

    const { createCredentials } = CredentialsService();

    const [errMsg, setErrMsg] = useState<string>();
    const [loading, setLoading] = useState(false);

    const schema = yup.object().shape({
        email: yup.string().email().required("Email is required"),
        password: yup.string()
            .required("Password is required")
            .matches(/^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/,
                "Password should contain, at least: 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number"),
        passwordConfirmation: yup
            .string()
            .required("Password confirmation is required")
            .oneOf([yup.ref("password")], "Passwords must match"),
    });

    useEffect(() => {
        setLoading(false);
    }, []);

    const getEmailFromUrl = () => {
        let query = location.search.substring(1);
        let vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == 'email') {
                return decodeURIComponent(pair[1]);
            }
        }
        return "";
    };

    const submitForm = async (values: any) => {
        setLoading(true);
        setErrMsg(undefined);

        let resp = await createCredentials({
            email: values.email,
            password: values.password
        });
        setLoading(false);
        if (resp.error) {
            setErrMsg(resp.error.message);
            return;
        }

        navigate(REGISTER_EMAIL_CONFIRM, {
            state: {
                email: values.email,
                password: values.password,
            },
        });
    };

    let emailFromUrl = getEmailFromUrl();

    return (
        <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
            <Container>
                <div className={"onboarding_logoContainer"}>
                    <HandicaddieLogo size={'lg'}/>
                </div>

                <div>
                    <span className={"heading"}>Register</span>
                </div>

                <Formik
                    validationSchema={schema}
                    onSubmit={submitForm}
                    initialValues={{
                        email: emailFromUrl,
                        password: "",
                        passwordConfirmation: "",
                    }}
                >
                    {({
                          handleSubmit,
                          handleChange,
                          handleBlur,
                          values,
                          touched,
                          isValid,
                          errors,
                      }) => (
                        <Form
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Row>
                                <Col>
                                    <Form.Label column={'lg'}>Email</Form.Label>
                                    <Form.Group controlId="detailsForm.Email">
                                        <Form.Control
                                            className="onboarding_input"
                                            type="email"
                                            name="email"
                                            placeholder="Email address"
                                            value={location?.state?.email}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <Form.Label column={'lg'} className={"onboarding_labelWithExplanation"}>Password</Form.Label>
                                    <span className={"onboarding_explanation"}>
                                        Now you can enter your password for your account.
                                    </span>
                                    <Form.Group controlId="detailsForm.Password" style={{ marginTop: '0.25em' }}>
                                        <Form.Control
                                            required
                                            className="onboarding_input"
                                            type="password"
                                            name="password"
                                            placeholder="Password"
                                            value={values.password}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                        />
                                        {touched.password && errors.password && (
                                                <Alert variant={"danger"}>
                                                    {errors.password}
                                                </Alert>
                                            )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group controlId="detailsForm.PasswordConfirmation" style={{ marginTop: '0.25em' }}>
                                        <Form.Control
                                            required
                                            className="onboarding_input"
                                            type="password"
                                            name="passwordConfirmation"
                                            placeholder="Password Confirmation"
                                            onBlur={handleBlur}
                                            value={values.passwordConfirmation}
                                            onChange={handleChange}
                                        />
                                        {touched.passwordConfirmation && errors.passwordConfirmation && (
                                                <Alert variant={"danger"}>
                                                    {errors.passwordConfirmation}
                                                </Alert>
                                            )}
                                    </Form.Group>
                                </Col>
                            </Row>

                            {errMsg && <ErrorText>{errMsg}</ErrorText>}

                            {!loading && <Button type="submit" disabled={loading} className={"forgotEmailConfirm_submitBtn"}>
                                REGISTER
                            </Button>}
                            {loading && <Button disabled={loading} onClick={() => {}} className={"forgotEmailConfirm_submitBtn"}>
                                <Spinner animation={"border"}/>
                            </Button>}
                        </Form>
                    )}
                </Formik>
            </Container>
        </div>
    )
}

export default RegisterCredentials;